<div class="p-4">
  <!-- Question Text -->
  <div class="mb-4">
    <label
      class="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5"
    >
      Question
    </label>
    <textarea
      rows="3"
      [(ngModel)]="service.editingQuestion.questionText"
      placeholder="Enter your question..."
      class="edit-input edit-option-textarea"
    ></textarea>
  </div>

  <!-- Multiple Choice Options -->
  @if (service.editingQuestion.type === QuestionType.MULTIPLE_CHOICE) {
    <div>
      <div class="flex items-center justify-between mb-2">
        <label
          class="text-xs font-medium text-gray-500 uppercase tracking-wide"
        >
          Options
        </label>
        <button
          (click)="addEditOption()"
          class="text-xs text-gray-500 font-medium hover:text-gray-700 transition-colors cursor-pointer flex items-center gap-1"
        >
          <lucide-icon
            [img]="icons.Plus"
            class="w-3.5 h-3.5"
          ></lucide-icon>
          Add option
        </button>
      </div>

      @for (
        option of service.editingQuestion.options;
        track option.id;
        let optIdx = $index
      ) {
        <div
          class="edit-option-row"
          [class.edit-option-correct]="option.isCorrect"
        >
          <!-- Letter Badge -->
          <span
            class="edit-option-letter"
            [class.edit-option-letter-correct]="option.isCorrect"
          >
            {{ getOptionLetter(optIdx) }}
          </span>

          <!-- Option Text Input -->
          <textarea
            rows="1"
            [(ngModel)]="option.text"
            placeholder="Option text..."
            class="edit-input edit-option-textarea flex-1 min-w-0"
          ></textarea>

          <!-- Three-dot Menu -->
          <button
            cdkOverlayOrigin
            #optionMenuTrigger="cdkOverlayOrigin"
            (click)="toggleOptionMenu(optIdx)"
            class="option-menu-trigger"
          >
            <lucide-icon
              [img]="icons.MoreVertical"
              class="w-4 h-4"
            ></lucide-icon>
          </button>

          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="optionMenuTrigger"
            [cdkConnectedOverlayOpen]="optionMenuOpenIdx === optIdx"
            [cdkConnectedOverlayHasBackdrop]="true"
            cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
            [cdkConnectedOverlayPositions]="menuPositions"
            (backdropClick)="closeOptionMenu()"
          >
            <div class="option-menu-popover">
              <button
                class="option-menu-item"
                [class.option-menu-item-correct]="option.isCorrect"
                [class.option-menu-item-disabled]="
                  service.isLastCorrectOption(optIdx)
                "
                [disabled]="service.isLastCorrectOption(optIdx)"
                (click)="toggleOptionCorrect(optIdx)"
              >
                <lucide-icon
                  [img]="
                    option.isCorrect ? icons.Check : icons.CheckCircle
                  "
                  class="w-4 h-4"
                ></lucide-icon>
                {{
                  option.isCorrect ? 'Unset correct' : 'Set as correct'
                }}
              </button>
              <div class="option-menu-divider"></div>
              <button
                class="option-menu-item"
                [disabled]="optIdx === 0"
                [class.option-menu-item-disabled]="optIdx === 0"
                (click)="moveEditOption(optIdx, 'up')"
              >
                <lucide-icon
                  [img]="icons.ChevronUp"
                  class="w-4 h-4"
                ></lucide-icon>
                Move up
              </button>
              <button
                class="option-menu-item"
                [disabled]="
                  optIdx === service.editingQuestion.options.length - 1
                "
                [class.option-menu-item-disabled]="
                  optIdx === service.editingQuestion.options.length - 1
                "
                (click)="moveEditOption(optIdx, 'down')"
              >
                <lucide-icon
                  [img]="icons.ChevronDown"
                  class="w-4 h-4"
                ></lucide-icon>
                Move down
              </button>
              <div class="option-menu-divider"></div>
              <button
                class="option-menu-item option-menu-item-danger"
                (click)="deleteEditOption(optIdx)"
              >
                <lucide-icon
                  [img]="icons.Trash2"
                  class="w-4 h-4"
                ></lucide-icon>
                Delete
              </button>
            </div>
          </ng-template>
        </div>
      }
    </div>
  }

  <!-- Short Answer / Essay info -->
  @if (
    service.editingQuestion.type === QuestionType.SHORT_ANSWER ||
    service.editingQuestion.type === QuestionType.ESSAY
  ) {
    <div
      class="py-3 px-4 bg-gray-50 rounded-lg border border-dashed border-gray-200 mt-2"
    >
      <p class="text-xs text-gray-400 italic">
        @if (service.editingQuestion.type === QuestionType.SHORT_ANSWER) {
          Students will provide a short text answer
        } @else {
          Students will write an essay response
        }
      </p>
    </div>
  }
</div>
